import { useNavigate } from 'react-router-dom'

// Konferenztyp-Kürzel für Badge
const KONFERENZTYP_KURZEL = {
  'Bundeskonferenz': 'BK',
  'Regionalkonferenz': 'RK',
  'Workshop': 'WS',
  'Fortbildung': 'FB',
  'Andere': '—',
}

export default function VideoCard({ paper, isSearchResult }) {
  const navigate = useNavigate()

  const handleClick = () => {
    navigate(`/video/${paper.thema}`)
  }

  const kuerzel = KONFERENZTYP_KURZEL[paper.konferenztyp] ?? null

  return (
    <div
      onClick={handleClick}
      className={`
        bg-white rounded-lg shadow hover:shadow-lg transition cursor-pointer overflow-hidden flex flex-col h-full
        ${isSearchResult ? 'animate-in fade-in zoom-in duration-200' : ''}
      `}
      style={isSearchResult ? {
        animation: 'fadeInZoom 0.3s ease-out'
      } : {}}
    >
      <style>{`
        @keyframes fadeOutShrink {
          from {
            opacity: 1;
            transform: scale(1);
          }
          to {
            opacity: 0;
            transform: scale(0.95);
          }
        }

        @keyframes fadeInZoom {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes reorderCards {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
      `}</style>

      {/* Cover Image */}
      {paper.cover_path ? (
        <img
          src={`/content/${paper.cover_path}`}
          alt={paper.title}
          loading="lazy"
          className="w-full h-40 object-cover"
        />
      ) : (
        <div className="bg-gray-200 h-40 flex items-center justify-center">
          <span className="text-gray-500">Video {paper.thema}</span>
        </div>
      )}

      {/* SMW Logo Bar */}
      <div className="h-3 bg-gradient-to-r from-green-600 to-green-500"></div>

      {/* Content */}
      <div className="p-4 flex-grow flex flex-col justify-between">
        {/* Title */}
        <h3 className="font-bold text-base mb-3 line-clamp-2">
          {paper.title}
        </h3>

        {/* Footer */}
        <div className="text-sm text-gray-600 space-y-2">
          {/* Author */}
          <p className="truncate">{paper.author1}</p>

          {/* Kategorie | Ort | BK/RK — Jahr rechts */}
          <div className="text-xs flex items-center justify-between">
            <span className="truncate mr-2">
              {typeof paper.kategorie === 'string'
                ? paper.kategorie.split(' ').join(' | ')
                : Array.isArray(paper.kategorie)
                  ? paper.kategorie.join(' | ')
                  : paper.kategorie}
              {paper.ort && ` | ${paper.ort}`}
              {kuerzel && ` | ${kuerzel}`}
            </span>
            <span className="font-semibold text-gray-800 shrink-0">{paper.jahr}</span>
          </div>
        </div>
      </div>
    </div>
  )
}
